<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headersite01" class="chapter" epub:type="frontmatter" id="site">
<header id="headersite01">
<h1 class="ctfm"><a class="xref" href="#/chilie0007#toc">Companion Website</a></h1>
</header>
<p class="pf"><span aria-label="xii" class="page" id="pxii" role="doc-pagebreak"></span><span aria-label="xiii" class="page" id="pxiii" role="doc-pagebreak"></span>Readers are encouraged to access digital materials associated with this book at <a class="url" href="http://www.djangogen.com" target="_blank">http://www.djangogen.com</a>. This companion website provides supplementary images, audio, video, and links to further information.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lie-0010.vue?8b1f0936